
<form *ngIf="form&& fields" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" >
    <div class="ui-dialog-content Loyalty">
        <div class="ui-g-12 ui-md-12">
            <span class="label" [ngClass]="{'required': !fields.serviceId.nullable}">{{ fields.serviceId.keyName }}</span>
            <p-dropdown [options]="serviceList" formControlName="serviceId" [style]="{'width':'100%'}" [filter]="true" #itemSelected></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.serviceId"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-12">
            <span class="label" [ngClass]="{'required': !fields.dateStart.nullable}">{{ fields.dateStart.keyName }}</span>
            <p-calendar dateFormat="dd/mm/yy" formControlName="dateStart" showIcon="true" #dateStart></p-calendar>
            <app-validation-msg [arrayValidators]="[validators.dateStart]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.dateStart"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-12">
            <span class="label" [ngClass]="{'required': !fields.dateEnd.nullable}">{{ fields.dateEnd.keyName }}</span>
            <p-calendar dateFormat="dd/mm/yy" formControlName="dateEnd" showIcon="true" #dateEnd></p-calendar>
            <app-validation-msg [arrayValidators]="[validators.dateEnd]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.dateEnd"></app-validation-msg>
        </div>
    </div>

    <div class="ui-dialog-footer" style="display: flex; justify-content: center;">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-plus"
                iconPos="left" label="{{ 'common.add' | translate }}" (click)="addService(itemSelected.value, dateStart, dateEnd);"></button>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-services/store-common-services-form.component.html